// ─── FILE DOWNLOAD ────────────────────────────────────────────────────────────
// One place to hand a generated file to the browser, shared by every exporter
// (order workbook, catalogue workbook, …). Object URLs — not data: URIs —
// because a large workbook base64-encodes past the URL length ceiling in some
// mobile browsers.

export function saveBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  // Revoke late: Safari cancels an in-flight download when the URL dies early.
  setTimeout(() => URL.revokeObjectURL(url), 10_000);
}

export const XLSX_MIME =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
